module.exports = __webpack_public_path__ + "img/1F4A6.df9c7003.svg";